import useInput from "hooks/use_input"

import { FormControl, FormControlLabel, RadioGroup, Radio, FormHelperText } from "@mui/material"

import MaleIcon from "@mui/icons-material/Male"
import FemaleIcon from "@mui/icons-material/Female"

const RadioCard = (props) => {
  const { value, label, selected, icon } = props

  return (
    <FormControlLabel
      value={value}
      label={label}
      control={
        <Radio
          icon={icon}
          checkedIcon={icon}
          sx={{
            "& .MuiSvgIcon-root": {
              fontSize: 48,
              color: selected ? "bg.light" : "primary.main",
            },
          }}
        />
      }
      sx={{
        flex: 1,
        p: 2,
        border: "1px solid",
        borderRadius: "16px",
        ml: "2px",
        borderColor: "primary.main",
        backgroundColor: selected ? "primary.main" : "bg.light",
      }}
    />
  )
}

const HumanGender = () => {
  const id = "gender"

  const validate = (value) => {
    if (value === "") return "This field is required"

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <FormControl sx={{ my: 1 }} error={errorMessage?.length > 0}>
      <RadioGroup
        row
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onTouchEnd={handleBlur}
      >
        <RadioCard value="male" label="" selected={inputValue === "male"} icon={<MaleIcon />} />
        <RadioCard
          value="female"
          label=""
          selected={inputValue === "female"}
          icon={<FemaleIcon />}
        />
      </RadioGroup>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  )
}

export default HumanGender
